module.exports = __webpack_public_path__ + "img/feature_buy_en.4cd384b7.png";